import { Directive, HostListener } from "@angular/core";
import { NgControl } from "@angular/forms";

@Directive({
  selector: "[uppercase]",
})
export class UppercaseDirective {
  constructor(private ngControl: NgControl) {}

  @HostListener("blur")
  onBlur() {
    const value = this.ngControl.value;
    if (typeof value === "string") {
      const uppercase_value = value.toUpperCase();
      this.ngControl.control.setValue(uppercase_value);
    }
  }
}
